export { Link } from './Link';
export type { LinkProps } from './Link';
